import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { PersonInput } from './PersonSelect';

export default function TrustsStep({ form, updateForm, addPersonToList }) {
    const updateTrust = (f, v) => updateForm({ trust: { ...form.trust, [f]: v } });
    const el = React.createElement;

    return el('div', { className: 'space-y-8' },
        // Trust Type Section
        el('div', { className: 'p-4 border border-stone-200 space-y-4' },
            el('h4', { className: 'font-serif text-lg' }, 'Trust Information'),
            el('p', { className: 'text-sm text-muted-foreground' }, 'Complete this section if the client is setting up a trust'),
            el('div', { className: 'grid grid-cols-1 md:grid-cols-2 gap-4' },
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Trust Type'),
                    el('select', { 
                        value: form.trust.trust_type || '', 
                        onChange: e => updateTrust('trust_type', e.target.value), 
                        className: 'w-full h-10 px-3 border border-stone-200 bg-white rounded-none', 
                        'data-testid': 'trust-type-select' 
                    },
                        el('option', { value: '' }, 'Select trust type...'),
                        el('option', { value: 'revocable_living' }, 'Revocable Living Trust'),
                        el('option', { value: 'irrevocable' }, 'Irrevocable Trust'),
                        el('option', { value: 'special_needs' }, 'Special Needs Trust'),
                        el('option', { value: 'charitable' }, 'Charitable Trust'),
                        el('option', { value: 'testamentary' }, 'Testamentary Trust'),
                        el('option', { value: 'spendthrift' }, 'Spendthrift Trust')
                    )
                ),
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Trust Name'),
                    el(Input, { 
                        value: form.trust.trust_name || '', 
                        onChange: e => updateTrust('trust_name', e.target.value), 
                        className: 'rounded-none',
                        placeholder: 'e.g., The Smith Family Trust'
                    })
                )
            )
        ),
        
        // Trustee Section
        el('div', { className: 'p-4 border border-stone-200 space-y-4' },
            el('h4', { className: 'font-serif text-lg' }, 'Trustee Information'),
            el('div', { className: 'grid grid-cols-1 md:grid-cols-2 gap-4' },
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Trustee Name'),
                    el(PersonInput, { 
                        value: form.trust.trustee_name || '', 
                        onChange: (val) => updateTrust('trustee_name', val), 
                        onAddPerson: addPersonToList,
                        people: form.people || [],
                        spouse: form.spouse,
                        children: form.children,
                        placeholder: 'Select or type name',
                        relationship: 'trustee'
                    })
                ),
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Trustee Relationship'),
                    el(Input, { 
                        value: form.trust.trustee_relationship || '', 
                        onChange: e => updateTrust('trustee_relationship', e.target.value), 
                        className: 'rounded-none',
                        placeholder: 'e.g., self, spouse, bank'
                    })
                )
            ),
            el('div', { className: 'grid grid-cols-1 md:grid-cols-2 gap-4' },
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Successor Trustee Name'),
                    el(PersonInput, { 
                        value: form.trust.successor_trustee_name || '', 
                        onChange: (val) => updateTrust('successor_trustee_name', val), 
                        onAddPerson: addPersonToList,
                        people: form.people || [],
                        spouse: form.spouse,
                        children: form.children,
                        placeholder: 'Select or type name',
                        relationship: 'successor trustee'
                    })
                ),
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Successor Trustee Relationship'),
                    el(Input, { 
                        value: form.trust.successor_trustee_relationship || '', 
                        onChange: e => updateTrust('successor_trustee_relationship', e.target.value), 
                        className: 'rounded-none',
                        placeholder: 'e.g., daughter, son, bank'
                    })
                )
            )
        ),
        
        // Trust Assets & Instructions
        el('div', { className: 'p-4 border border-stone-200 space-y-4' },
            el('h4', { className: 'font-serif text-lg' }, 'Trust Details'),
            el('div', { className: 'space-y-2' },
                el(Label, null, 'Trust Purpose'),
                el(Textarea, { 
                    value: form.trust.trust_purpose || '', 
                    onChange: e => updateTrust('trust_purpose', e.target.value), 
                    className: 'rounded-none min-h-[80px]',
                    placeholder: 'Describe the purpose of the trust...'
                })
            ),
            el('div', { className: 'space-y-2' },
                el(Label, null, 'Distribution Instructions'),
                el(Textarea, { 
                    value: form.trust.distribution_instructions || '', 
                    onChange: e => updateTrust('distribution_instructions', e.target.value), 
                    className: 'rounded-none min-h-[80px]',
                    placeholder: 'How and when should trust assets be distributed...'
                })
            ),
            el('div', { className: 'space-y-2' },
                el(Label, null, 'Special Instructions'),
                el(Textarea, { 
                    value: form.trust.special_instructions || '', 
                    onChange: e => updateTrust('special_instructions', e.target.value), 
                    className: 'rounded-none min-h-[80px]',
                    placeholder: 'Any other instructions or provisions...'
                })
            )
        )
    );
}
